import { Controller } from "@hotwired/stimulus"

import TomSelect from "tom-select";

export default class extends Controller {

  connect() {
    let select = new TomSelect("#" + this.element.id, {
      plugins: {
        remove_button: { title:'Remove'}
      }
    });
  }
}
